<highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag"
    class="bar-chart"></highcharts-chart>
